export const EN_LOCALE = 'en';
export const EN_LOCALE_TITLE = 'English';
export const DEFAULT_LOCALE = EN_LOCALE;

export const REGION = {
  RU: 'RU',
  US: 'US',
  FR: 'FR',
};

export const REGION_EMAIL_SUPPORT = {
  [REGION.US]: 'info@form.one',
  [REGION.RU]: 'support_formone@pravo.tech',
  [REGION.FR]: 'info@form.one',
};
